/**
 * Swiping between zones while playing, on touch screens: a swipe left shows
 * the next zone and a swipe right the previous, as pages turn. The same
 * `play.goTo` the zone chips and ←/→ use; this only reads the swipe.
 */

/** Shorter than this (CSS px), a swipe is a tap that wobbled. */
const MIN_SWIPE_PX = 50;
/** It has to be clearly sideways: this many times more across than down. */
const SIDEWAYS_RATIO = 1.5;

/** The zone step a swipe asks for: +1, -1, or 0 for none. `dx`/`dy` are its travel. */
export function swipeStep(dx: number, dy: number): -1 | 0 | 1 {
  if (Math.abs(dx) < MIN_SWIPE_PX || Math.abs(dx) < Math.abs(dy) * SIDEWAYS_RATIO) return 0;
  return dx < 0 ? 1 : -1;
}
